import { OnAnimationFrame } from "../../../animation/OnAnimationFrame";
import { ElementType } from "../../../dom-tools/ElementType";
import { Composer } from "../Composer";

export class ComposerElement
{
  static readonly type = new ElementType( "composer-block" );

  static applyOnDocument( onAnimationFrame:OnAnimationFrame )
  {
    ComposerElement.type.forAllInDoc( e => ComposerElement.applyOnElement( e, onAnimationFrame ) );
  }

  static applyOnElement( e:Element, onAnimationFrame:OnAnimationFrame )
  {
    Composer.start( e, onAnimationFrame );
  }
}
